<template>
  <div class="flex flex-col h-full flex-grow-0">
    <div class="p-8 bg-gray-800">
      <div class="w-full">
        <div class="md:flex md:items-center md:justify-between">
          <div class="flex-1 min-w-0">
            <h2 class="text-2xl font-bold leading-7 text-white sm:text-3xl sm:truncate">
              {{ $t('contactsMerge.page.title') }}
            </h2>
          </div>
        </div>
      </div>
    </div>
    <template v-if="status === 'idle'">
      <div class="bg-white px-8 sticky top-0 border-b z-10">
        <nav class="text-sm w-full">
          <RouterLink
            :to="{ name: 'accounts.accountId.contactMerge' }"
            class="px-4 inline-flex h-12 items-center justify-center"
            :class="[
              $route.name === 'accounts.accountId.contactMerge'
                ? 'text-blue-600 bg-gray-200'
                : 'text-gray-600 hover:bg-gray-200 hover:text-blue-900',
            ]"
          >
            {{ $t('contactsMerge.navigation.oneByOne.label') }}
          </RouterLink>

          <RouterLink
            :to="{ name: 'accounts.accountId.contactBulkMerge' }"
            class="px-4 inline-flex h-12 items-center justify-center"
            :class="[
              $route.name === 'accounts.accountId.contactBulkMerge'
                ? 'text-blue-600 bg-gray-200'
                : 'text-gray-600 hover:bg-gray-200 hover:text-blue-900',
            ]"
          >
            {{ $t('contactsMerge.navigation.bulk.label') }}
          </RouterLink>
        </nav>
      </div>
      <RouterView @bulk-merge-started="checkStatus" />
    </template>
    <div v-else-if="status === 'processing'" class="p-8">
      <BaseCard>
        <BaseCardBody>
          <h3 class="text-sm font-medium text-blue-800">
            {{ $t('contactsBulkMerge.inProgressNotificationCard.title') }}
          </h3>
          <div class="rounded-md bg-blue-50 p-4 mt-4">
            <div class="text-sm text-blue-700">
              <ol class="space-y-1">
                <li>
                  {{ $t('contactsBulkMerge.inProgressNotificationCard.remainingMergeOperations') }}
                  <strong>{{ remainingMergeOperations }}</strong>
                </li>
                <li>
                  {{ $t('contactsBulkMerge.inProgressNotificationCard.estimatedCompletionAt') }}
                  <strong>{{ estimatedCompetionAt }}</strong>
                </li>
              </ol>
            </div>
          </div>
        </BaseCardBody>
      </BaseCard>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { accountDuplicateContactsClient } from '@/api/clients';

export default {
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      mergeStatus: null,
      poll: null,
    };
  },
  computed: {
    status() {
      return this.mergeStatus?.status || null;
    },
    remainingMergeOperations() {
      return this.mergeStatus?.pending_merge_operations_count || 0;
    },
    estimatedCompetionAt() {
      if (!this.mergeStatus?.estimated_completion_at) {
        return 'N/A';
      }

      const local = moment.utc(this.mergeStatus.estimated_completion_at).local();

      const formatted = local.format('DD/MM/YYYY HH:mm');
      const fromNow = local.fromNow(true);

      return `${formatted} (${fromNow})`;
    },
  },
  methods: {
    async checkStatus() {
      try {
        const response = await accountDuplicateContactsClient.mergeStatus(this.accountId);

        this.mergeStatus = response.data;

        if (response.data?.status === 'processing') {
          this.poll = setTimeout(() => {
            this.checkStatus();
          }, 1000);
        }
      } catch (errors) {
        //
      }
    },
  },
  created() {
    this.checkStatus();
  },
  destroyed() {
    if (this.poll) {
      clearTimeout(this.poll);
    }
  },
};
</script>
